import { AccountType } from '@/common/types'

export const ACCOUNT_TYPE_LABELS = {
    [AccountType.INDIVIDUAL]: 'Individual',
    [AccountType.JOINT]: 'Joint',
    [AccountType.INDIVIDUAL_TRUST]: 'Individuals as trustees',
    [AccountType.COMPANY_TRUST]: 'Company as trustee',
    [AccountType.COMPANY]: 'Company',
    [AccountType.ADVISER]: 'Adviser',
}

export const COMMON_COPY = {
    close: 'Close',
    submit: 'Submit',
}

export const ONBOARDING_COPY = {
    next: 'Next',
    back: 'Back',
    login: {
        emailSignup: 'Sign up with your email address',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        createAccount: 'Create account',
        loginTitle: 'Login to your account',
        signupTitle: 'Create an account',
        signupDescription: 'Please note, SIX is currently only offered to AU citizens',
    },
    confirmUser: {
        pageTitle: 'Confirm Account',
        title: 'Enter verification code',
        description: 'Enter the 6-digit code sent to',
        newCode: "Didn't receive the code? ",
        resendIt: 'Resend it',
    },
    name: {
        pageTitle: 'About you',
    },
    aboutYou: {
        pageTitle: 'About you',
        title: 'About you',
        description: 'Enter your full name as it appears on your ID, without initials.',
        addressDescription: 'Enter your residential address.',
        mobileDescription: 'Enter your mobile number and date of birth.',
        form: {
            salutation: 'Title',
            salutationPlaceholder: 'Eg Mr, Mrs, Ms',
            firstName: 'First name',
            firstNamePlaceholder: 'First name',
            lastName: 'Last name',
            lastNamePlaceholder: 'Last name',
            middleName: 'Middle name (optional)',
            middleNamePlaceholder: 'Middle name',
            dateOfBirth: 'Date of birth',
            dateOfBirthPlaceholder: 'DD-MM-YYYY',
            residentialAddress: 'Residential address',
            postalAddress: 'Postal address',
            differentPostalAddress: 'Add different postal address',
            mobile: 'Mobile number',
            mobileAuPlaceholder: '400 000 000',
            mobileNzPlaceholder: '20 000 0000',
        },
    },
    MobileVerification: {
        pageTitle: 'Mobile verification',
        title: 'Mobile verification',
        description: 'Enter the 6-digit code sent to:',
    },
    accountType: {
        pageTitle: 'Account type',
        title: 'Select account type',
        description: 'Choose the right account that best suits your investing needs.',
        options: {
            individual: {
                label: ACCOUNT_TYPE_LABELS[AccountType.INDIVIDUAL],
                description:
                    'A personal trading account in your name for getting involved in campaigns, investing in shares, ETFs and other securities.',
            },
            trustOrSelfManagedSuperFund: {
                label: 'Trust or self managed super fund',
                description: 'A trading account for your trust or self-managed superannuation fund.',
            },
            individualTrust: {
                label: ACCOUNT_TYPE_LABELS[AccountType.INDIVIDUAL_TRUST],
                description: 'Two or more individuals manage the trust’s or SMSF’s investments.',
            },
            companyTrust: {
                label: ACCOUNT_TYPE_LABELS[AccountType.COMPANY_TRUST],
                description: 'A registered company manages the trust’s or SMSF’s investments.',
            },
            company: {
                label: ACCOUNT_TYPE_LABELS[AccountType.COMPANY],
                description: 'A trading account for your company.',
            },
        },
    },
    kycInit: {
        pageTitle: 'ID Verification',
        title: "Let's verify your identity",
        description:
            'To trade on the SIX platform, you must fill out a verification form for proof of identity. Do you wish to continue?',
        alert: {
            title: 'A completion PIN will be emailed to you',
            description:
                'By proceeding, you will receive an email from us with a four digit completion PIN which you will be required to enter at the end of form to submit your application.',
        },
        points: {
            title: 'You will need:',
            INDIVIDUAL: ['Identification documents - Drivers License or Passport'],
            JOINT: ['Identification documents - Drivers License or Passport'],
            frankieOneIndividual: [
                'A few minutes to complete the application',
                "ID on you (this could be a driver's licence, passport or Medicare card)",
                'You must be over 18 years of age',
                'You must be an Australian citizen, permanent resident or Visa holder.',
            ],
            INDIVIDUAL_TRUST: [
                'Identification documents - Drivers license or Passport',
                'Trust or SMSF ABN',
                'Trust deed',
            ],
            COMPANY_TRUST: [
                'Identification documents - Directors License or Passport',
                'Trust or SMSF ABN',
                'Trust deed',
                'Trustee company ACN',
                'Company officer details',
            ],
            COMPANY: [
                'Identification documents - Drivers licence or Passport',
                'Company officer details',
                'Australian Business Number (ABN)',
                'Australian Company Number (ACN)',
                'Tax file number (TFN)',
            ],
            ADVISER: [],
        },
        secondaryButton: 'Skip',
        primaryButton: 'Start verification',
        errorToast: 'There was an issue starting your ID verification. Please try again later.',
    },
    kyc: {
        pageTitle: 'ID Verification',
        title: 'Verify your identity',
        description: 'Enter your details to complete ID verification as required by Australian law.',
        primaryButton: 'Continue',
        consentText:
            "Your personal information will be checked against third party records, including a credit reporting agency and the Australian Government's Document Verification Service (DVS), to assess whether your personal information matches those records and to assist in verifying your identity for the purposes of the Anti-Money Laundering and Counter-Terrorism Act 2006. If you disagree with having your personal information shared with third parties or your identity verified we may not be able to open an account for you. By continuing, you agree that you are authorised to provide us these details and you understand that it will be checked against third party records for this purpose.",
    },
    termsAndConditions: {
        pageTitle: 'Terms and conditions',
        title: 'Terms and conditions',
        description:
            'To open your SIX account, you will first need to agree to the terms below so you can complete account activities like share trading and deposits and withdrawals.',
        primaryButton: 'I agree',
        agreementText: 'By clicking “I agree”, you confirm that you have read and agree to SIX’s terms and conditions.',
        sections: {
            chessSponsorship: {
                title: 'CHESS Sponsorship',
                description:
                    "FinClear is SIX's partner on trade execution. Opt in below to create a CHESS account and establish a trading account with SIX.",
                checkboxLabel:
                    'I agree to FinClear Execution Ltd establishing a new sponsored HIN and acting as my CHESS sponsoring broker.',
            },
            informedConsent: {
                title: 'SIX terms and conditions',
                description: 'SIX is a share trading platform that allows you to buy and sell shares on the ASX',
            },
            finclearCashhub: {
                title: 'FinClear Cash Hub',
                description:
                    "SIX uses FinClear's Cash Hub for deposits and withdrawals. You will need to nominate a bank account before you can add or withdraw money from your account.",
                checkboxLabel:
                    'I agree to FinClear Services establishing a Cash Hub VRN for the settlement of my investments.',
            },
            monoova: {
                title: 'Monoova Cash Wallet',
                description:
                    "SIX uses Monoova for deposits and withdrawals. You will need to agree to Monoova's terms and conditions before you can add money or withdraw from your account.",
            },
            finclear: {
                title: 'FinClear Terms and Conditions',
                checkboxLabel:
                    'I authorise SIX and FinClear to use my nominated bank account details for deposits to and withdrawals from my Cash Hub account.',
            },
            frankieOne: {
                title: 'Identity verification',
            },
        },
        updatedLabel: (date: string) => `Updated ${date}`,
    },
    survey: {
        pageTitle: 'Your investing',
        title: 'Your investing',
        description: 'We need a few more details to get your trading account set up.',
        form: {
            occupation: 'Occupation',
            investmentPurpose: 'What is the main goal for this account with SIX?',
            expectedTradeFrequency: 'How often do you intend to trade?',
            expectedTradeAmount: 'How much do you think you will trade each time?',
        },
    },
    confirmation: {
        pageTitle: 'Confirm Your Details',
        title: 'Confirm your details',
        description: 'Please verify your account details.',
        descriptionWithAdviser: 'Please confirm the details your adviser has entered.',
        adviserLabel: 'Your Adviser',
        adviserDescription: 'This adviser will be authorised to manage your SIX account.',
        contactAdviserNote: 'If any of these details are incorrect, please contact your adviser to update them.',
        confirmButton: 'I confirm',
        form: {
            salutation: 'Title',
            firstName: 'First name',
            middleName: 'Middle name',
            lastName: 'Last name',
            dateOfBirth: 'Date of birth',
            mobileNumber: 'Mobile number',
            residentialAddress: 'Residential address',
            postalAddress: 'Postal address',
        },
    },
    accountCreated: {
        pageTitle: 'Account Created',
        title: 'Account created',
        adviserMessage: 'Your adviser now has access to trade on your account.',
        nonAdviserMessage: 'Your account is now ready to use.',
        secondaryMessage: 'No further action is required. You may close this window.',
    },
    redirect: "Hang tight! You've proceeded to the next stage of completing your application",
}

export const DIALOG_COPY = {
    noKyc: {
        title: 'Please verify your identity',
        description: `We need to collect some personal information to verify your identity before you can start trading.\n\nIt’s important you enter your details as accurately as possible. This will save time and get you into your new account right away!`,
        primaryButton: 'Start identity verification',
    },
    noKycAdviser: {
        title: 'Identity verification required',
        description:
            "We need to collect some personal information to verify the applicant's identity before trading can occur. It's important the details entered are as accurate as possible. This will save time and get the new account right away!",
        primaryButton: 'Start identity verification',
    },
    noTradingAccount: {
        title: 'Your trading account is being set up',
        description: 'This usually takes around 20 minutes in business hours, or by 10:30am the next business day.',
        swiftIdDescription:
            "This usually takes around 2 business days. We'll let you know via email as soon as it is ready.",
    },
}

export const NAVIGATION_COPY = {
    dashboard: 'Dashboard',
    campaigns: 'Campaigns',
    portfolio: 'Portfolio',
    invest: 'Invest',
    findStocks: 'Find stocks',
    wallet: 'Wallet',
    blogs: 'Blogs',
    mobileBottomNav: {
        dashboard: 'Dashboard',
        invest: 'Invest',
        campaigns: 'Campaigns',
        portfolio: 'Portfolio',
        wallet: 'Wallet',
        more: 'More',
    },
    mobileMoreNav: {
        title: 'More',
        walletDescription: 'View and manage balances',
        investDescription: 'Discover shares to invest in',
        findStocksDescription: 'Discover shares and ETFs',
        blogsDescription: 'Learn about shareholder activism and investing',
    },
    instrumentSearch: {
        triggerAriaLabel: 'Open instrument search',
        title: 'Search Shares and ETFs',
        placeholder: 'Search Shares and ETFs',
        noResults: 'We were unable to find any matching results for your search',
    },
    adviserDesktop: {
        clients: 'Clients',
        account: 'Account',
    },
    adviserClients: {
        title: 'Clients',
        addClient: 'Add client',
        searchPlaceholder: 'Search clients',
        searchLabel: 'Search clients',
        switchingAccount: 'Switching account...',
        foundCount: '{count} client{plural} found',
        noClientsFound: 'No clients found.',
        tryChangingSearchTerms: 'Try changing your search terms',
        accountName: 'Account name',
        firstName: 'First name',
        lastName: 'Last name',
        id: 'ID',
        type: 'Type',
        email: 'Email',
        statusColumn: 'Status',
        actionColumn: 'Action',
        selectAccount: 'Select account',
        addFirstClient: 'Add your first client',
        addFirstClientDescription:
            'Create a client profile to start managing investments, portfolios, trading activity in one place.',
        tabs: {
            active: 'Active',
            inProgress: 'In Progress',
        },
        inProgress: {
            title: 'In progress clients',
            description: 'Clients with incomplete applications will appear here.',
            emptyState: 'No clients in progress',
            actionRequired: 'Action required',
            inProgressLabel: 'In progress',
            clientsCount: '{count} clients',
        },
        status: {
            kycNotStarted: 'Complete KYC to activate',
            kycInProgress: 'KYC in progress',
            kycSubmitted: 'KYC submitted',
            kycFailed: 'KYC failed - contact support',
            awaitingConfirmation: 'Set up trading account',
            accountSetupInProgress: 'Account setup in progress',
            active: 'Active',
            // Keep existing ones for backward compatibility:
            confirmationFailed: 'Confirmation failed',
            clientConfirmation: 'Client confirmation',
            accountProcessing: 'Account processing',
        },
        actions: {
            resume: 'Resume',
            resendLink: 'Resend link',
        },
    },
    account: {
        pageTitle: 'Account',
        moreDescription: 'Manage your personal and account details',
        tabs: {
            accountHolders: 'Account holders',
            accountDetails: 'Account details',
            accountSettings: 'Account settings',
        },
        personalDetailsTitle: 'Account holder details',
        accountDetailsTitle: 'Account details',
        communicationTitle: 'Communications',
        accountSettingsTitle: 'Account settings',
        tradeConfirmationTitle: 'Trade confirmation',
        registryCommunicationTitle: 'Registry communications',
        fields: {
            name: 'Name',
            email: 'Email',
            mobileNumber: 'Mobile number',
            address: 'Address',
            postalAddress: 'Postal address',
            accessType: 'Access level',
        },
        accountFields: {
            accountName: 'Account name',
            accountType: 'Account type',
            accountNumber: 'Account number',
            tradingAccountNumber: 'Trading account number',
            hin: 'HIN',
            tfn: 'Tax file number (TFN)',
            tfnProvidedValue: 'Provided',
            tradeConfirmationEmail: 'Trade confirmation email',
            tradeConfirmationNotProvided: 'Not provided',
            tradeConfirmationAdd: 'Add',
        },
        accountSettingsFields: {
            tradeConfirmationEmail: 'Trade confirmation email',
            adviserTradeConfirmationEmail: 'Adviser trade confirmation email',
            registrationAddress: 'Registration address',
        },
        tradeConfirmationForm: {
            pageTitle: 'Trade confirmation email',
            description: 'This email will be used for receiving trade confirmations.',
            emailLabel: 'Email',
            emailPlaceholder: 'Enter your email here',
            cancel: 'Cancel',
            save: 'Save',
        },
        tradeConfirmationSuccess: {
            pageTitle: 'Trade confirmation email added',
            backToAccount: 'Back to account',
        },
        registrationAddressForm: {
            pageTitle: 'Registration address',
            description: 'This address will be used for your account registration.',
            cancel: 'Cancel',
            save: 'Save',
        },
        registrationAddressSuccess: {
            pageTitle: 'Registration address added',
            backToAccount: 'Back to account',
        },
        support: {
            title: 'Need to update your details?',
            description: 'Send a message to a SIX team member who can assist.',
            cta: 'Contact support',
        },
        tfnForm: {
            pageTitle: 'Tax file number',
            description: '',
            disclaimerPrefix:
                'By providing my (Tax File Number) TFN I authorise Sustainable Investment Exchange (SIX) to collect and use it for investment purposes and meeting ATO reporting obligations. I understand that providing my TFN is optional, but that withholding tax may apply if I choose not to provide it. My TFN will be handled in accordance with the Privacy (Tax File Number) Rule 2015 and SIX’s ',
            privacyPolicyLinkText: 'Privacy Policy↗',
            tfnLabel: 'Tax file number (TFN)',
            tfnPlaceholder: '123 456 789',
            cancel: 'Cancel',
            save: 'Save',
        },
        tfnSuccess: {
            pageTitle: 'Tax file number added',
            backToAccount: 'Back to account',
        },
    },
    resumeTitle: 'Resume Application',
    resumeDescription: 'Complete your trading application now',
    toDo: {
        title: 'To do',
        description: 'How to get trading with SIX.',
        items: [
            {
                number: 1,
                title: 'Complete application',
                description: 'Verify your identity to access trading.',
            },
            {
                number: 2,
                title: 'Fund your wallet',
                description: 'Add money to your wallet to buy shares.',
            },
            {
                number: 3,
                title: 'Read our getting started guide',
                description: 'Hear from our founder Adam Verwey on how to build your ethical portfolio.',
            },
            {
                number: 4,
                title: 'Make your first investment',
                description: 'Invest in shares and build your ethical portfolio.',
            },
            {
                number: 5,
                title: 'Join your first campaign',
                description: 'Change big organisations for the better through activist investing.',
            },
        ],
    },
    profile: 'Profile',
    addAccount: 'Add account',
    addIndividualTitle: 'Add individual account',
    addIndividualDescription: 'Add a personal trading account',
    manage: 'Manage',
    accountSettings: 'Account settings',
    rewards: 'Rewards',
    supportAndFaqs: 'Support & FAQs',
    logout: 'Log out',
    installPwaApp: 'Install app',
    accountTypes: {
        [AccountType.INDIVIDUAL]: 'Individual',
        [AccountType.JOINT]: 'Joint',
        [AccountType.INDIVIDUAL_TRUST]: 'Trust',
        [AccountType.COMPANY_TRUST]: 'Company',
        [AccountType.COMPANY]: 'Company',
        [AccountType.ADVISER]: 'Adviser',
    },
}

export const PROMOTIONS_COPY = {
    trustAccounts: {
        title: '🎉 Trust & SMSF accounts are here',
        description: 'You can now invest and trade on behalf of your Trust or SMSF on SIX.',
        ctaPrefix: 'Open ',
        ctaAction: 'Profile → Add account',
        ctaSuffix: ' to get started.',
        gotIt: 'Got it',
    },
}

export const VERIFICATION_COPY = {
    resend: 'Resend code',
    sent: 'Sent!',
    waiting: 'Resend code in {time}',
}

export const APPLICATION_COPY = {
    progressBar: {
        title: 'Trading application',
        type: 'Application type',
        status: 'Application status',
    },
    create: {
        title: 'Select account type',
        newAccountDescription: 'You can add multiple SIX account types and access them all with your current SIX login',
        description:
            'To trade on the SIX platform, you must fill out a verification form for proof of identity. Do you wish to continue?',
        adviserDescription:
            'To create a client account, you must complete verification for proof of identity. Do you wish to continue?',
        requirementTitle: 'Checklist',
        requirementSubtitle: 'To open a {accountType} account, you will need:',
    },
    accountType: {
        title: 'Select account type',
        description: 'You can add multiple SIX account types and access them all with your current SIX login',
        adviserDescription: 'Choose the account type to add for your client.',
        comingSoonLabel: 'Coming soon',
    },
    participantDetails: {
        title: 'Account details',
        description: 'Add details of your client as it matches their ID.',
        emailLabel: 'Email',
        emailPlaceholder: 'Email',
        titleLabel: 'Title',
        titlePlaceholder: 'e.g. Mr, Ms, Mrs',
        firstNameLabel: 'First name',
        firstNamePlaceholder: 'First name',
        middleNameLabel: 'Middle name',
        middleNameOptionalLabel: '(optional)',
        middleNamePlaceholder: 'Middle name',
        lastNameLabel: 'Last name',
        lastNamePlaceholder: 'Last name',
    },
    participantComms: {
        title: 'Client communications',
        description: 'What type of communications would you like your client to receive?',
        byEmail: 'By email',
        tradeConfirmationsLabel: 'Trade confirmations',
        tradeConfirmationsDescription: 'Electronic copies of contract notes',
        footer: 'Communications are sent via email. You can change your preferences later.',
        byPost: 'By post',
        tradeRegistryAddressLabel: 'Trade registration address',
        tradeRegistryAddressDescription: 'Where should trade registry documents be sent?',
    },
    participantSurvey: {
        title: "Your client's investing",
        description: 'Please answer these questions on behalf of your client for AML requirements.',
        form: {
            occupation: 'Occupation',
            investmentPurpose: 'What is the main goal for this account with SIX?',
            expectedTradeFrequency: 'How often do you intend to trade?',
            expectedTradeAmount: 'How much do you think you will trade each time?',
        },
    },
    participantAccessReview: {
        title: 'Client access',
        description: "Choose the level of access you'd like for your client.",
        options: {
            NONE: {
                title: 'None',
                description: 'Only you and your team can access the account.',
            },
            VIEW: {
                title: 'View only',
                description:
                    'The client can access the account to view their portfolio, but cannot place orders or manage their money.',
            },
            TRADE: {
                title: 'Transact',
                description:
                    'Full access. The client can access the account to place trades, view their portfolio, and manage their money.',
            },
            FULL: {
                title: 'Transact',
                description:
                    'Full access. The client can access the account to place trades, view their portfolio, and manage their money.',
            },
        },
        viewOnlyComingSoonLabel: 'Coming soon',
    },
    termsAndConditions: {
        title: 'Terms and conditions',
        authorityStatement: 'The client has provided me written authority to act on their behalf.',
        agreementStatement: 'By clicking “I agree”, you confirm the above.',
    },
    confirmation: {
        backAccounts: 'Back to account types',
        title: 'Before you start',
        warning:
            'Once you proceed past this point you will be unable to change the account type. Please ensure you have selected the correct account type.',
        adviserWarningTitle: 'Your client will need to approve checks once complete',
        adviserWarningDescription:
            'Once our partner FrankieOne has successfully completed required checks for KYC, we will send an email out to your client to confirm that they authorise you to create an account on behalf of them.',
        errorToast: 'There was an issue adding your new account. Please try again later.',
    },
    resume: {
        title: 'How to resume your application',
        description: 'This {type} application for {firstName} {lastName} is incomplete',
        stepOne: {
            title: '1. Copy 4-digit completion PIN',
            description: 'You’ll need to enter the 4 digit PIN above when you resume your application.',
            pin: 'PIN:',
        },
        stepTwo: {
            title: '2. Resume application',
            description: 'Click the button above to resume your application.',
            button: 'Resume your application',
        },
        support: 'If you have any queries regarding your application please contact us at {email}',
    },
}

export const DASHBOARD_COPY = {
    blogs: 'Blogs',
    alerts: {
        verificationUnsuccessful: {
            title: 'We were unable to automatically verify your identity',
            description: 'Our team will be in touch with you shortly to assist you with the verification process.',
        },
    },
}

export const ESG_COPY = {
    title: 'Ethical screens',
    positiveThemesIncluded: '{count} positive screens used',
    issuesAvoided: '{count} negative screens used',
    issuesAvoidedTooltip: {
        title: 'Negative screens',
        description:
            'This is a snapshot of the negative screens that apply to the ETF(s). To see more detail about the screens, including any materiality thresholds, please read SIX’s ethical profile or visit the ETF provider’s website for the most up-to-date information.',
    },
}

export const REWARDS_COPY = {
    pageTitle: 'Rewards',
    freeTradesTitle: 'Free trades',
    freeTradesDescription:
        'Brokerage fees will be automatically rebated on your next completed trade(s). This is capped at $9.90 per trade.',
    remaining: 'remaining',
    noRewards: 'No rewards available at this time.',
    noRewardsButton: 'Back to dashboard',
    expires: 'Expires on ',
    freeTradeItem: {
        title: 'Free trade applied',
        description: '$9.90 will be automatically rebated if a free trade is available when this trade completes.',
        completedDescription: '$9.90 was rebated for this trade.',
    },
}

export const BUNDLE_COPY = {
    back: 'Back to Dashboard',
    performance: 'Performance',
    about: 'About',
    viewBundle: 'View bundle',
    breakdown: 'Breakdown',
    learnMore: 'Learn more',
    chartTitle: 'Price chart',
    moreBundles: 'More bundles',
    chartDisclaimer: 'This chart is not inclusive of distributions or dividends.',
    lastUpdate: 'Returns at {date}',
    ethicalTagsDescription:
        'The following screens apply to the whole bundle. View individual ETFs to see their ethical screens.',
    buyBundle: 'Buy bundle',
    performanceDisclaimer: 'Past performance is not a reliable indicator of future performance.',
    performanceInfoTooltip:
        'The returns are based on information provided by the ETF providers, and assume an initial investment of 33.33% into each of the ETFs. Returns are calculated in Australian dollars and do not reflect brokerage or the bid ask spread that investors incur when buying and selling units on the ASX. Returns are after fund management costs, assume reinvestment of any distributions and do not take into account tax paid as an investor in the Funds.',
    aboutDisclaimer:
        'These bundles do not take into account your personal financial circumstances and should not be considered advice or a recommendation. We encourage you to do your own research and consider what’s right for you. You may also wish to seek professional advice before investing.',
    etfsIncluded: 'ETFs included',
    buy: 'Buy',
    year1: '1 year',
    year3: '3 years',
    year5: '5 years',
    yearsSuffix: ' /yr',
    buyDisclaimer:
        'Your first purchase in every new company or ETF on the ASX needs to be more than $500.00 + brokerage.',
}

export const ORDER_FORM_COPY = {
    availableFunds: 'Available funds',
    bundle: 'Bundle',
    addFunds: 'Add funds',
    warnings: {
        insufficientFunds: 'Not enough available funds',
        firstTrade:
            'Your first purchase in every new company or ETF on the ASX needs to be more than $500.00 + brokerage. ',
        belowMinimum: 'Below minimum trade size. ',
        numberErrors: ' error(s) in this order',
    },
    bundleAdjustmentInfo: 'You can adjust the amounts of each ETF to suit your investment needs.',
    howMuchToInvest: 'How much to invest',
    includingBrokerage: 'including brokerage',
    setMinimum: 'Set to minimum',
    breakdown: 'Breakdown',
    brokerage: 'Brokerage',
    estimateBrokerage: 'Estimated brokerage',
    reset: 'Reset',
    review: 'Review',
    brokerageAmount: '$9.90 per trade',
    amount: 'Amount',
    total: 'Total',
    unitsAt: ' units @ ',
    estimatedAmount: 'Estimated amount',
    infoToolTip: {
        amount: 'Includes a 2% buffer for market orders.',
        brokerage:
            'Each trade you make with SIX will have a minimum flat brokerage fee of $9.90 on trades up to $9,000. Brokerage of 0.11% will apply to trades above $9,000.',
    },
    amend: 'Amend',
    submit: 'Submit buy order',
    securities: 'Securities',
    reviewTitle: 'Review buy order',
    orderType: 'Order type',
    orderTypeMapping: {
        MARKET_TO_LIMIT: 'Market',
        LIMIT: 'Limit',
    },
    disclaimers: [
        'You are in a live trading environment. All investments carry risks. Please ensure you have understood and accept these risks before investing. It is important to know that you are vulnerable to market volatility and losses. Any information provided by SIX is general in nature only, and does not consider your individual circumstances.',
    ],
    freeTradeItem: {
        title: 'Free trade(s) applied',
        description:
            '$9.90 will be automatically rebated for each security traded if free trades are available when it completes.',
    },
}

export const ORDER_CONFIRMATION_COPY = {
    thankYouTitle: 'Thanks for placing your {} order',
    failedTitle: 'Some orders were submitted successfully',
    failedOrders: 'Failed orders',
    failedOrdersAlert: 'Order for the following trade(s) failed and you were not charged. Please resubmit.',
    submittedOrders: 'Submitted orders',
    summary: 'Order summary',
}

export const ORDER_FILL_CANCELLATION_COPY = {
    title: 'Cancel unfilled order request',
    content: [
        'Your order is partially filled ({filled}/{requested} shares). Are you sure you want to request to cancel the unfilled order to buy ',
        '{unfilled} shares',
        ' of ',
        '{securityCode}',
        '?',
    ],
    warning: {
        title: 'Cancellation not guaranteed',
        content:
            'Your cancellation request will be queued for processing. If the remaining portion fills before it’s processed, the order may still complete.',
    },
    back: 'No, go back',
    confirm: 'Yes, cancel order',
}

export const ORDER_REVIEW_COPY = {
    review: 'Review',
    order: 'Order',
    orderReference: 'Order Reference',
    orderStatus: 'Order Status',
    security: 'Security',
    orderType: 'Order Type',
    expiryDate: 'Expiry Date',
    shares: 'Shares',
    filled: 'Filled',
    unfilled: 'Unfilled',
    totalShares: 'Total Shares',
    limitPrice: 'Limit Price',
    averageCompletionPrice: 'Average Completion Price',
    estimated: 'Estimated',
    amount: 'Amount',
    brokerage: 'Brokerage',
    total: 'Total',
    cancelOrder: 'Cancel order',
    cancelUnfilledOrder: 'Cancel unfilled order',
}

export const INVEST_COPY = {
    title: 'Invest',
    bundlesTitle: 'ETF starter bundles',
    bundlesDescription: 'A bundle of ETFs (exchange-traded funds) pre-selected by SIX’s ESG analysts.',
    trendingEtfsTitle: 'Trending ETFs',
    trendingEtfsTooltip:
        'Trending ETFs are based on the most traded ETFs on our platform over the previous calendar month. This does not constitute financial advice or a recommendation. Do your own research before investing.',
}

export const FIND_STOCKS_COPY = {
    title: 'Find stocks',
    description: 'Search and filter all ASX listed securities to find the right investments for you.',
    included: '✅ Include',
    includedTitle: '✅ Select positive screens to include',
    includedSmall: '✅',
    includedPlaceholder: 'Select positive screens',
    excluded: '❌ Avoid',
    excludedTitle: '❌ Select negative screens to avoid',
    excludedSmall: '❌',
    excludedPlaceholder: 'Select negative screens',
    results: '{count} results',
    showing: 'Showing {count} results',
    noPositiveFilters: {
        title: 'Ready to build a portfolio that matches your values?',
        description: 'Select from the filters above to discover investments you care about.',
    },
    noResults: {
        title: 'No exact matches',
        description: 'Try changing or removing some of your filters.',
    },
    etfCard: {
        viewStock: 'View etf',
        yearToDateChange: 'Year to date',
        negativeScreens: '{count} negative screens',
        positiveScreens: '{count} positive screens',
    },
    showEtfs: 'Show ETFs',
    showStocks: 'Show stocks',
    clear: 'Clear',
    etfs: 'ETFs',
    stocks: 'Stocks',
}

export const PWA_APP_COPY = {
    installTitle: 'View in SIX App',
    installDescription: 'Add it to your Home Screen for extensive experience and easy access.',
    installCta: 'Install for free',
    appleInstructions: {
        title: 'Instructions:',
        steps: [
            'Open your main browser',
            'Press More if no Share icon',
            'Press Share in Navigation bar',
            'Find or view more and select “Add to Home Screen”',
        ],
        button: 'Maybe next time',
    },
    setup: {
        title: 'Set up passkey',
        description: 'Your passkey is tied to this device. It will be used to sign in securely.',
        benefits: ['Stronger security', 'Faster and easier login', 'No more remembering passwords'],
        setupButton: 'Create passkey',
        skipButton: 'Skip',
    },
    authRequired: {
        title: 'Use passkey',
        description: 'Use your passkey to access the app or use your login details',
        usePasskeyButton: 'Use passkey',
        logoutButton: 'Use login details',
    },
    authError: {
        title: 'Authentication failed',
        description: 'Passkey authentication failed. Please try again or log out.',
        usePasskeyButton: 'Use passkey',
        logoutButton: 'Use login details',
    },
}

export const EXIT_INTENT_COPY = {
    title: "Before you go, we'd love to help improve your experience",
    question: 'Why did you decide not to proceed with the ETF bundle?',
    pickMany: '(Pick as many reasons as you’d like.)',
    options: [
        'Fees were higher than expected',
        'The returns weren’t strong enough',
        'It didn’t align with my ethical values',
        'Other (please specify)',
    ],
    otherPlaceholder: 'Tell us what we missed...',
    submit: 'Submit',
}

export const BLOGS_COPY = {
    title: 'Blogs',
    header: 'Blogs',
    readMore: 'Read more',
    description: 'Insights and updates from the world of ethical investing and activism.',
    searchPlaceholder: 'Search by name or content',
    searchAriaLabel: 'Search blogs',
    categoriesTitle: 'Categories',
    noResultsTitle: 'No results found',
    noResultsDescription: 'Try searching using other keywords or changing the filters.',
    notFoundTitle: 'Blog not found',
    blogsAvailable: '{count} blogs available',
    read: 'read',
}

export const WALLET_COPY = {
    addFunds: {
        title: 'Add funds',
        minimumAmountTitle: 'How much should I transfer?',
        minimumAmountDescription:
            'The minimum amount you will need per buy order is up to approximately $580 depending on the share price, to cover the minimum order size plus a 2% buffer, and fees.',
        havePaid: 'I have paid',
        willTransferLater: "I'll transfer later",
    },
    depositOptions: {
        payIdTabLabel: 'PayID',
        bankAccountTabLabel: 'Bank Account',
        payIdSetupMessage: 'Your PayID is being setup, please use bank account to deposit, or contact support.',
        payIdLabel: 'Your unique PayID email',
        payIdPlaceholder: 'Your PayID is being setup',
        payIdNameLabel: 'Account name',
        bankAccountNameLabel: 'Bank account name',
        bankAccountNumberLabel: 'Bank account number',
        bsbLabel: 'BSB',
        copiedFeedback: 'Copied',
    },
}
